import { render, staticRenderFns } from "./underAttack.vue?vue&type=template&id=2df76230&"
import script from "./underAttack.vue?vue&type=script&lang=js&"
export * from "./underAttack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports